<template>
    <div class="">
        <b-form class="step-form" @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-lg-12">
                    <h3>Risk Profiling Questionnaire</h3>
                </div>
                <div class="col-lg-12 investment-question-radio-group">
                    <b-form-group>
                        <div
                            v-for="(field, index) in data.data"
                            :key="index"
                            :v-if="is_data_fetched"
                        >
                            <component
                                :is="field.type"
                                :field="field"
                                :data-segment-id="dataSegmentId"
                                :is-required="isRequired"
                                @change="setValue(index, ...arguments)"
                            ></component>
                        </div>

                        <!-- <div
                            v-for="(field, index) in checkUsers(data)"
                            :key="index"
                            :v-if="is_data_fetched"
                        >
                            <checkbox
                                :field="field"
                                :data-segment-id="dataSegmentId"
                                @check="setValue(-1, ...arguments)"
                            ></checkbox>
                        </div> -->
                    </b-form-group>
                </div>

                <div class="col-lg-4">
                    <b-button
                        size="sm"
                        variant="secondary"
                        class="mr-3"
                        @click="onBack"
                    >
                        Back
                    </b-button>
                    <base-button
                        btn-type="submit"
                        btn-variant="primary"
                        btn-label="CONTINUE"
                        :class="loading ? 'disabled' : ''"
                        :disabled="loading"
                    ></base-button>
                </div>
            </div>
        </b-form>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
import _ from 'lodash'
import axios from 'axios'
const apiUrl = process.env.VUE_APP_API_URL
// import Checkbox from '../../components/form-builder/Checkbox.vue'
export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        Radio,
        Checkbox,
    }, // End of Component > components
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props
    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            // data: "",
            selected: [],
            selected_ids: [],
            score: '',
            test: [],
            data: '',
            is_data_fetched: false,
            isRequired: true,
        }
    }, // End of Component > data
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),
        ...mapGetters(['dataSegmentId', 'loading', 'form']),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed
    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */
    watch: {}, // End of Component > methods
    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        this.$store.dispatch('trackEvent', {
            event: 'JS | Register RPQ Investment',
        })

        this.selected = this.$store.getters.getField(
            'investmentProduct.selectOptions'
        )
            ? this.$store.getters.getField('investmentProduct.selectOptions')
            : []

        const reqData = { dataSegmentId: this.dataSegmentId }
        axios
            .post(apiUrl + 'configurations/investments', reqData)
            .then((response) => {
                let languageOption =
                    this.$store.getters.getField('languageOption')

                if (languageOption == 'urd') {
                    for (var i = 0; i < response.data.data.length; i++) {
                        response.data.data[i].label =
                            response.data.data[i].urduLabel

                        response.data.data[i].options.map((option) => {
                            let tempEngText = option.text
                            let tempUrduText = option.urduLabel
                            option.urduLabel = tempEngText
                            option.text = tempUrduText
                            return option
                        })
                    }
                }

                this.data = response.data
                this.is_data_fetched = true
                // console.log('data', this.data)
                // this.setValuesForRadio(this.data.data);
            })
            .catch((error) => {
                this.errorMessage = error.message
            })
    }, // End of Component > watch
    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */

        // radioUsers(data) {
        //     if (this.is_data_fetched) {
        //         console.log('before', data.data)
        //         const cloneData = [...data.data]
        //         cloneData.splice(4, 1)
        //         return cloneData
        //     }
        // },
        // checkUsers(data) {
        //     if (this.is_data_fetched) {
        //         const cloneData = []
        //         cloneData.push(data.data[4])
        //         console.log("clone data 2 ", cloneData)
        //         return cloneData
        //     }
        // },

        setValue(index, data) {
            var self = this
            this.selected.forEach(function (val, ind) {
                if (val['index'] == index) {
                    self.selected.splice(ind, 1)
                    return false
                }
            })

            this.selected.push({
                index: index,
                optionId: data.optionId,
                quesId: data.parentID,
                optionTitle: data.optionTitle,
                quesTitle: data.parentTitle,
            })
            // console.log('SELECTED', JSON.stringify(this.selected))
        },
        async onSubmit() {
            // console.log(this.selected)
            // validate the form fields
            const result = await this.$validator.validateAll()
            // console.log("on submit", this.selected)
            // Check if validation fails
            if (
                result &&
                this.selected &&
                this.selected.length == this.data.data.length
            ) {
                this.$store.commit('updateField', {
                    key: 'rcForms.form5.valid',
                    value: true,
                })
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-risk-product',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    // console.log(JSON.stringify(this.selected))
                    this.$router.push('/register-customer/risk-product')
                }
                this.$store.commit('updateField', {
                    key: 'investmentProduct.selectOptions',
                    value: this.selected,
                })
            } else {
                this.$store.commit('updateField', {
                    key: 'rcForms.form5.valid',
                    value: false,
                })
                // let notSelectedField = this.radioGroupValidate(this.selected);
                const errorMsg = 'All questions must be answered'
                this.$store.commit('setError', errorMsg)
                // this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        radioGroupValidate(selected) {
            var tempSelectedArray = JSON.parse(JSON.stringify(selected))
            tempSelectedArray.sort(function (a, b) {
                return a.index - b.index
            })
            for (var i = 0; i < this.data.data.length; i++) {
                if (tempSelectedArray) {
                    if (tempSelectedArray[i]) {
                        if (tempSelectedArray[i].index != i) {
                            return i
                        }
                    } else {
                        return i
                    }
                } else {
                    return i
                }
            }
        },
        onBack() {
            if (this.$route.meta.publicRegistration === true) {
                this.$router.push({
                    name: 'public-registration-kyc',
                    params: {
                        dataSegmentId: this.dataSegmentId,
                    },
                })
            } else {
                this.$router.push('/register-customer/KYC')
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
